enum Status {
  PENDING = "PENDING",
  CLEARED = "CLEARED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
  SPENT = "SPENT",
  SPENT_REFUND = "SPENT_REFUND",
  REFUND_SPENT = "REFUND_SPENT",
  EXPIRED = "EXPIRED",
  REWARD_WALLET_CLEARED = "REWARD_WALLET_CLEARED",
  REWARD_WALLET_SPENT = "REWARD_WALLET_SPENT",
  REWARD = "REWARD",
  SCHEDULED_SPEND = "SCHEDULED_SPEND",
  SCHEDULED_TOPUP = "SHEDULED_TOPUP",
  SENT = "SENT",
  RECEIVED = "RECEIVED",
  REDEEMED = "REDEEMED",
  USED = "USED",
  UNUSED = "UNUSED",
  POINTS_REQUEST_PENDING = "POINTS_REQUEST_PENDING",
  POINTS_REQUEST_APPROVED = "POINTS_REQUEST_APPROVED",
  POINTS_REQUEST_REJECTED = "POINTS_REQUEST_REJECTED",
  POINTS_REQUEST_CANCELLED = "POINTS_REQUEST_CANCELLED",
  CASHBACK = "CASHBACK"
}

export default Status
